import { APP_STORE_URL } from "@groupeo/shared";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import logo from "@/src/common/assets/images/logo.png";
import { env } from "@/src/common/constants/env";
import { MARKETING_ROUTES } from "../constants/marketing-routes";
import { LanguageSwitcher } from "./language-switcher";
import { StoreButton } from "./store-button";

export function SiteHeader() {
	const { t } = useTranslation("marketing");

	return (
		<header className="sticky top-4 z-20 rounded-full border border-white/10 bg-[rgba(8,11,18,0.78)] px-5 py-3 shadow-[0_24px_60px_-42px_rgba(0,0,0,0.68)] backdrop-blur">
			<div className="flex items-center justify-between gap-4">
				<Link to={MARKETING_ROUTES.HOME} className="flex items-center gap-3">
					<img
						src={logo}
						alt={`${env.APP_NAME} icon`}
						width={44}
						height={44}
						loading="eager"
						decoding="async"
						className="size-11 rounded-2xl shadow-[0_18px_36px_-24px_rgba(255,90,95,0.72)]"
					/>
					<div>
						<p className="text-base font-semibold tracking-[-0.03em] text-white">{env.APP_NAME}</p>
						<p className="text-xs uppercase tracking-[0.24em] text-white/45">{t("nav_label")}</p>
					</div>
				</Link>
				<nav
					aria-label={t("nav_aria_primary")}
					className="hidden flex-wrap items-center justify-end gap-x-4 gap-y-2 text-sm text-white/72 lg:flex"
				>
					<Link to={MARKETING_ROUTES.FEATURES} className="transition-colors hover:text-white">
						{t("nav_features")}
					</Link>
					<Link to={MARKETING_ROUTES.FAQ} className="transition-colors hover:text-white">
						{t("nav_faq_page")}
					</Link>
					<Link to={MARKETING_ROUTES.ABOUT} className="transition-colors hover:text-white">
						{t("nav_about")}
					</Link>
					<Link to={MARKETING_ROUTES.DOWNLOAD} className="transition-colors hover:text-white">
						{t("nav_download")}
					</Link>
					<Link to={MARKETING_ROUTES.CONTACT} className="transition-colors hover:text-white">
						{t("nav_contact")}
					</Link>
				</nav>
				<div className="flex items-center gap-3">
					<LanguageSwitcher />
					<div className="hidden sm:flex">
						<StoreButton href={APP_STORE_URL} label={t("nav_cta")} variant="coral" />
					</div>
				</div>
			</div>
		</header>
	);
}
